'use client';

import { useMemo, useState } from 'react';

import type { SearchComboboxConfig } from '@/shared/components/search-combobox';

const useHeaderSearch = (searchProp?: SearchComboboxConfig) => {
  const [defaultQuery, setDefaultQuery] = useState('');

  return useMemo<SearchComboboxConfig>(() => {
    if (searchProp) return searchProp;

    return {
      emptyStateLabel: 'No encontramos coincidencias todavía.',
      onPreviewSelect: () => {},
      onQueryChange: (value: string) => {
        setDefaultQuery(value);
      },
      onSubmit: (event) => {
        event.preventDefault();
      },
      placeholder: '¿Qué quieres aprender?',
      previewEnabled: false,
      previewItems: [],
      query: defaultQuery,
    };
  }, [defaultQuery, searchProp]);
};

export default useHeaderSearch;
